import React from 'react';
import { useIntl } from 'react-intl';
import {
    applicationId,
    confirmationMessage,
    description,
    intentGeneral,
} from '../constants/feedback';
import getFeedbackSubmissionURL from '../utils/getFeedbackSubmissionURL';
import Feedback from './Feedback';

const FeedbackModule = () => {
  const { formatMessage } = useIntl();
  return (
    <Feedback
      feedbackIntent={intentGeneral}
      applicationId={applicationId}
      description={formatMessage({ id: description })}
      feedbackSubmissionPageIdentifier={getFeedbackSubmissionURL}
      confirmationMessage={formatMessage({
        id: confirmationMessage,
      })}
      displayMode="dark"
    />
  );
};

export default FeedbackModule;
